<template>
  <SidebarComponent /> <!-- Componente sidebar -->
  <div class="dashboard-layout">
    <div class="content-container"> <!-- Contenitore per il contenuto principale -->
      <div class="card-container">

        <div class="titolo-card">
          <h1>Seleziona i servizi per il nuovo ordine</h1>
        </div>

        <!-- Lista dei prodotti con checkbox -->
        <div class="titolo-card2">
          <div v-for="product in products" :key="product.id" class="product-item">
            <input 
              type="checkbox" 
              :id="product.id" 
              :value="product" 
              v-model="selectedProducts" 
            />
            <label :for="product.id">{{ product.name }} - €{{ product.price }}</label>

            <!-- Bottone per aprire l'accordion -->
            <button class="staff-button-neutral" @click="toggleAccordion(product.id)"><span class="material-icons">info</span>
</button>

            <!-- Accordion per i dettagli del prodotto -->
            <div v-if="currentAccordion === product.id" class="product-details">
              <p>Categoria: {{ product.category }}</p>
              <p>Descrizione: {{ product.description }}</p>
              <p>Durata: {{ product.scadenza }}</p>
              <!-- Altri dettagli del prodotto -->
            </div>
          </div>
        </div>

        <!-- Sezione per visualizzare il totale e procedere al pagamento -->
        <div class="card-actions2">
          <p>Totale nel carrello: {{ totalPrice }} €</p>
          <a href="#" class="btn-call staff-button-positive" @click="handleSaveOrder">
            <span class="material-icons">add_shopping_cart</span>
            Procedi al pagamento
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getFirestore, collection, getDocs } from 'firebase/firestore';

import SidebarComponent from '../SidebarComponent.vue'; // Importa SidebarComponent

export default {
  components: {
    SidebarComponent // Registra il componente SidebarComponent
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const products = ref([]);
    const selectedProducts = ref([]);
    const currentAccordion = ref(null); // Aggiunto per gestire l'accordion attiva
    const db = getFirestore();

    const fetchProducts = async () => {
      const productsCollection = collection(db, "products");
      const querySnapshot = await getDocs(productsCollection);
      products.value = querySnapshot.docs.map(doc => {
        let data = doc.data();
        data.price = parseFloat(data.price);
        return { id: doc.id, ...data };
      });
    };

    const totalPrice = computed(() => {
      return selectedProducts.value.reduce((acc, product) => acc + parseFloat(product.price), 0).toFixed(2);
    });

    const saveOrder = () => {
      if (selectedProducts.value.length === 0) {
        alert('Seleziona almeno un prodotto.');
        return;
      }

      // Ottieni la data corrente e l'UID dell'utente
      const currentDate = new Date();
      const userUID = store.state.userUid;

      const orderDetails = {
        products: selectedProducts.value.map(p => ({ id: p.id, name: p.name, price: p.price, description: p.description })),
        totalPrice: parseFloat(totalPrice.value),
        orderDate: currentDate.toISOString(),
        createdBy: userUID,
      };

      store.commit('SET_ORDER_DETAILS', orderDetails);
      router.push({ name: 'OrderSummary' });
    };

    const handleSaveOrder = (event) => {
      event.preventDefault();
      saveOrder();
    };

    const toggleAccordion = (productId) => {
      currentAccordion.value = currentAccordion.value === productId ? null : productId;
    };

    onMounted(fetchProducts);

    return {
      products,
      selectedProducts,
      totalPrice,
      handleSaveOrder,
      currentAccordion,
      toggleAccordion
    };
  },
};
</script>



  
<style scoped>

.material-icons {
  margin-left: 0px;
  margin-right: 0px;
}
.titolo-card2 {
  background-color: #202020; /* Sfondo scuro per il titolo */
  color: #ffffff; /* Testo chiaro */
  padding: 20px; /* Padding intorno al titolo */
  margin-bottom: 20px; /* Spazio sotto il titolo */
  border-radius: 17px; /* Bordi arrotondati */
}

.product-item {
  display: flex; /* Disponi gli elementi in linea */
  align-items: center; /* Allinea verticalmente i componenti */
  margin-bottom: 10px; /* Spazio tra gli elementi */
}

.product-item input[type="checkbox"] {
  margin-right: 10px; /* Spazio tra la checkbox e il label */
}

.product-item label {
  color: #ccc; /* Colore del testo per i label */
  font-size: 1em; /* Dimensione del font */
}


.card-actions2 {
  display: flex;
  align-items: center; /* Allinea verticalmente gli elementi */
  justify-content: space-between; /* Spazia gli elementi equamente */
  padding: 20px; /* Padding intorno agli elementi */
  background-color: #282828; /* Colore di sfondo del contenitore */
  border-radius: 17px; /* Angoli arrotondati */
  margin-top: 20px; /* Spazio sopra il contenitore */
  color: #ffffff;
  padding-left: 30px;
}

.card-actions2 p {
  margin: 0; /* Rimuove il margine predefinito */
  font-weight: bold; /* Testo in grassetto */
}

.btn-call {
  display: flex;
  align-items: center; /* Allinea verticalmente icona e testo */
  background-color: #c11600; /* Colore di sfondo del pulsante */
  color: white; /* Colore del testo */
  padding: 10px 20px; /* Padding intorno al testo */
  border-radius: 13px; /* Angoli arrotondati del pulsante */
  text-decoration: none; /* Rimuove la sottolineatura del link */
  font-weight: bold; /* Testo in grassetto */
  transition: background-color 0.3s; /* Transizione per l'hover */
}

.btn-call span.material-icons {
  margin-right: 10px; /* Spazio tra l'icona e il testo */
}

.btn-call:hover {
  background-color: #3e8e41; /* Colore di sfondo al passaggio del mouse */
}

button {
  background: none; /* Rimuove lo sfondo */
  border: none; /* Rimuove il bordo */
  cursor: pointer; /* Cambia il cursore quando passi sopra il bottone */
  margin: 0; /* Rimuove il margine (opzionale) */
  padding-left: 20px;
}

button:hover {
  background: none; /* Rimuove lo sfondo */
  border: none; /* Rimuove il bordo */
  cursor: pointer; /* Cambia il cursore quando passi sopra il bottone */
  margin: 0; /* Rimuove il margine (opzionale) */
  padding-left: 20px;
}

.product-details {
  background-color: #121212;
padding-left: 20px;
padding-right: 20px;
padding-bottom: 10px;
padding-top: 10px;
border-radius: 7px;
}

</style>

